import { Card, Kontakt, type KontaktProps } from '@elbklar/ui';
import { RouterLink } from '@/components/layout/RouterLink';
import { mitHerkunft, type Herkunft } from '@/lib/herkunft';
import type { Contact } from '@/types';

/**
 * CRM-Kontakt auf die Props von `Kontakt` aus @elbklar/ui.
 *
 * `herkunft` nimmt die Kunden- oder Partnerseite mit, von der aus geklickt
 * wird (siehe lib/herkunft.ts): Am Handy geht der Weg zum Kontakt ueber diese
 * Karte, und ohne Herkunft endet der Rueckweg nach dem Bearbeiten in der
 * allgemeinen Kontaktliste.
 */
export function kontaktAus(c: Contact, herkunft: Herkunft = {}): KontaktProps {
  return {
    name: `${c.first_name} ${c.last_name}`,
    href: mitHerkunft(`/contacts/${c.id}`, herkunft),
    linkAs: RouterLink,
    position: c.role,
    primaer: c.is_primary,
    telefon: c.phone,
    mobil: c.mobile,
    email: c.email,
  };
}

/**
 * Ansprechpartner fürs Handy: je Kontakt Name und Position, darunter
 * „Anrufen“ und „E-Mail schreiben“. Der primäre Kontakt steht oben.
 */
export function AnsprechpartnerKarte({
  contacts,
  herkunft,
  className,
}: {
  contacts: Contact[];
  /** Seite, von der aus geklickt wird; fuehrt den Rueckweg mit. */
  herkunft?: Herkunft;
  className?: string;
}) {
  if (contacts.length === 0) return null;
  const sortiert = [...contacts].sort((a, b) => Number(b.is_primary) - Number(a.is_primary));
  return (
    <Card title="Ansprechpartner" flush className={className}>
      <ul>
        {sortiert.map((c) => (
          <li key={c.id} className="border-b border-border px-5 py-3 last:border-b-0">
            <Kontakt darstellung="knoepfe" {...kontaktAus(c, herkunft)} />
          </li>
        ))}
      </ul>
    </Card>
  );
}
